import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'abq-logged-out',
    templateUrl: './logged-out.component.html',
    styleUrls: ['./logged-out.component.scss'],
    imports: [RouterLink]
})
export class LoggedOutComponent {

}
